<hard-modal
  [title]="form ? (form.get('id').value ? 'Редактирование' : 'Добавление') : ''"
  [actions]="actions"
  [dialogId]="dialogId"
  (closeModal)="close()"
>
  @if (loading) {
    <hard-loading></hard-loading>
  } @else {
    @if (form) {
      <div class="table-wrapper-content">
        <hard-form-grid
          [config]="{
            params: {
              direction: 'column',
              fields: config.fields,
            },
          }"
          [form]="form"
        ></hard-form-grid>
      </div>
    } @else {
      <hard-no-data
        [message]="'Произошла ошибка получения данных'"
      ></hard-no-data>
    }
  }
</hard-modal>

<ng-template #actions>
  <hard-button (click)="close()">Отмена</hard-button>

  <hard-button
    type="success"
    (click)="save()"
    [disabled]="loading"
  >
    Сохранить
  </hard-button>
</ng-template>
